import { BOARD_SIZE } from '../../config/board.ts'
import { createMinimaxPlayer } from './minimax.ts'
import type { Board, Move, Player } from './types.ts'

// 候補空マス列挙（forbidden 除外）
function listEmpties(
  board: Board,
  forbidden?: ReadonlySet<number>
): Move[] {
  const empties: Move[] = []
  for (let r = 0; r < BOARD_SIZE; r++) {
    for (let c = 0; c < BOARD_SIZE; c++) {
      if (board[r][c] !== 'empty') continue
      if (forbidden?.has(r * BOARD_SIZE + c)) continue
      empties.push({ row: r, col: c })
    }
  }
  return empties
}

// noiseRate の確率でランダム手、それ以外は minimax depth の最適手を返す。
//
// NORMAL 難易度向けに「5連筋は大抵防ぐが、3連先作りをときどき見逃して自滅する」を実現する。
// minimax が毎手ちゃんと計算されるため「最適手の質」は minimax2 同等。ランダム発動時のみ
// 別の候補にずらすことで、プレイヤーに勝機を残しつつ十分な手応えを維持する。
export function createNoisyMinimaxPlayer(depth: number, noiseRate: number): Player {
  const noisePct = Math.round(noiseRate * 100)
  const base = createMinimaxPlayer(depth)
  return {
    id: `noisy-mmx${depth}-${noisePct}`,
    name: `Noisy Minimax depth=${depth} (${noisePct}% random)`,
    decide(board, color, ctx) {
      const { rng, forbidden, allowedMoves } = ctx
      if (allowedMoves && allowedMoves.length > 0) {
        return allowedMoves[Math.floor(rng() * allowedMoves.length)]
      }

      // ノイズ発動: ランダム手を返す（空マスから一様選択）
      if (rng() < noiseRate) {
        const empties = listEmpties(board, forbidden)
        if (empties.length === 0) return null
        return empties[Math.floor(rng() * empties.length)]
      }

      // 通常時は minimax の最適手を返す
      return base.decide(board, color, ctx)
    },
  }
}
